module.exports = __webpack_public_path__ + "img/客服热线.098907c3.png";